import { render, staticRenderFns } from "./CategoriesUpsertDialog.vue?vue&type=template&id=6b576fd3"
import script from "./CategoriesUpsertDialog.vue?vue&type=script&lang=js"
export * from "./CategoriesUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports